import Resource from './Resource'

class ResponsibilityService extends Resource {
    async findAllResponsibilitiesByLaboratory(laboratoryId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/responsibilities`)
        return response.data
    }
}

export default new ResponsibilityService()

export const RESPONSIBILITIES = {
    PATHOLOGIST: 'PATHOLOGIST',
    RESIDENT: 'RESIDENT',
    REGISTRAR: 'REGISTRAR',
    ADMINISTRATIVE: 'ADMINISTRATIVE',
    GROSSING_COORDINATOR: 'GROSSING_COORDINATOR',
    GROSSING_RESPONSIBLE: 'GROSSING_RESPONSIBLE',
    GROSSING_CONTROLLER: 'GROSSING_CONTROLLER',
    CYTOLOGY_EXPERT: 'CYTOLOGY_EXPERT',
    GROSSING_TUTOR: 'GROSSING_TUTOR',
    PROCESSING_TECHNICIAN: 'PROCESSING_TECHNICIAN',
    PROCESSING_TUTOR: 'PROCESSING_TUTOR',
    PROCESSING_RESPONSIBLE: 'PROCESSING_RESPONSIBLE',
    PROCESSING_COORDINATOR: 'PROCESSING_COORDINATOR',
    PROCESSING_CONTROLLER: 'PROCESSING_CONTROLLER',
    EMBEDDING: 'EMBEDDING',
    CUTTING: 'CUTTING'
}
